import React, { useState } from "react";

export default ({ OrganizerList, handleShowForm, handleSearch }) => {
  const [search, setSearch] = useState("");
  const handleOnChange = ({ target }) => {
    setSearch(target.value);
  };
  return (
    <div className="container daftar-ca" style={{ padding: "50px 0px" }}>
      <p
        className="text-center"
        style={{ fontSize: "20px", marginBottom: "50px" }}
      >
        Lembaga Sertifikasi PSrE
      </p>
      <div className="row mx-0">
        <div className="col-lg-10 col-sm-12">
          <input
            className="form-control"
            type="text"
            placeholder="Cari"
            style={{
              padding: "10px 20px",
              height: "37px",
              borderRadius: "5px",
            }}
            onChange={handleOnChange}
          />
        </div>
        <div className="col-lg-2 col-sm-12">
          <button
            className="btn btn-blue w-100"
            onClick={() => handleSearch(search)}
          >
            Cari
          </button>
        </div>
      </div>
      <table
        className="table w-100"
        id="my-datatable"
        style={{ fontSize: "13px", marginTop: 40 }}
      >
        <thead>
          <tr>
            <td style={{width: '33.3%'}}>Nama Perusahaan</td>
            <td style={{width: '33.3%'}}>Status Akreditasi</td>
            <td style={{width: '33.3%'}}>Website</td>
          </tr>
        </thead>
        <tbody style={{marginBottom: 80}}>
          {OrganizerList.map((e) => {
            return (
              <tr>
                <td style={{width: '33.3%'}}>{e.name}</td>
                <td style={{width: '33.3%'}}>{e.accreditation}</td>
                <td style={{width: '33.3%'}}>
                  <a href={e.website} target="_blank">
                    {e.website}
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
